/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddEditEmployeeDto } from '../../models/add-edit-employee-dto';
import { NotificationMessage } from '../../models/notification-message';

export interface ApiEmployeeRegisterPost$Params {
  'api-version'?: string;
      body?: AddEditEmployeeDto
}

export function apiEmployeeRegisterPost(http: HttpClient, rootUrl: string, params?: ApiEmployeeRegisterPost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
  const rb = new RequestBuilder(rootUrl, apiEmployeeRegisterPost.PATH, 'post');
  if (params) {
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotificationMessage>;
    })
  );
}

apiEmployeeRegisterPost.PATH = '/api/employee/register';
